import { render } from "./NcrmExternalApiDeliveryDetailCard.vue?vue&type=template&id=6faceb83&scoped=true"
import script from "./NcrmExternalApiDeliveryDetailCard.vue?vue&type=script&lang=js"
export * from "./NcrmExternalApiDeliveryDetailCard.vue?vue&type=script&lang=js"

import "./NcrmExternalApiDeliveryDetailCard.vue?vue&type=style&index=0&id=6faceb83&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faceb83"]])

export default __exports__